<template>
  <div class="card">
    <div class="card-body">
      <b-row>
        <b-col>
          <b-form-group>
            <label for="cmbEtapa">Etapa</label>
            <b-form-select
              v-model="process"
              id="cmbEtapa"
              @change="changeProcces()"
              :disabled="
                role_id == 5 || role_id == 9 || role_id == 2 || role_id == 7
              "
            >
              <template slot="first">
                <option :value="null">-- Todas --</option>
              </template>
              <option value="C">Comercial</option>
              <option value="J">Jurídico</option>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group>
            <label for="cmbStaff">Responsable</label>
            <b-form-select
              v-if="process == 'C'"
              class="mb-3"
              id="cmbStaff"
              v-model="staff_id"
              :disabled="role_id == 5 || role_id == 2"
              @change="getTasks()"
            >
              <template slot="first">
                <option :value="null">
                  -- Por favor seleccione una opción --
                </option>
              </template>

              <option v-for="item in lstStaff" :key="item.id" :value="item.id">
                {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
              </option>
            </b-form-select>

            <b-form-select
              v-if="process == 'J'"
              class="mb-3"
              id="cmbStaff"
              v-model="staff_id"
              :disabled="role_id == 5 || role_id == 2"
              @change="getTasks()"
            >
              <template slot="first">
                <option :value="null" disabled>
                  -- Por favor seleccione una opción --
                </option>
              </template>

              <option
                v-for="item in lstLawyers"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
              </option>
            </b-form-select>

            <b-form-select
              v-if="process == null"
              class="mb-3"
              v-model="staff_id"
              :disabled="!isAdmin"
            >
              <template slot="first">
                <option :value="null">
                  -- Por favor seleccione una opción --
                </option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group>
            <label for="cmbTaskType">Tipo Atividad</label>
            <b-form-select
              id="cmbTaskType"
              v-model="type_id"
              @change="getTasks()"
            >
              <template slot="first">
                <option :value="null">
                  -- Por favor seleccione una opción --
                </option>
              </template>

              <option
                v-for="item in lstTaskType"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-form-group>
            <label for="cmbStatus">Estado</label>
            <b-form-select
              id="cmbStatus"
              v-model="status_id"
              @change="getTasks()"
            >
              <template slot="first">
                <option :value="null">
                  -- Por favor seleccione una opción --
                </option>
              </template>

              <option
                v-for="item in lstTaskStatus"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="customize-calendar">
        <full-calendar
          :config="config"
          :events="calendarEvents"
          @event-selected="viewtask"
        />
      </div>
    </div>

    <!-- MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->
    <div class="modal fade" id="dlgCrearActividad">
      <div class="modal-dialog modal-dialog-centered modal-success">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">ACTIVIDAD</h4>
            <button type="button" class="close" @click="closetask">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <div
              class="col-sm-12 text-right"
              v-if="this.taskSelected.customer_id"
            >
              <b-button
                size="sm"
                variant="primary"
                class="mr-1"
                title="Ir a la cuenta"
                @click="viewCustomer()"
              >
                <i class="fa fa-eye"></i> Ir a la cuenta
              </b-button>
            </div>

            <div
              class="col-sm-12 text-right"
              v-if="this.taskSelected.debtor_id"
            >
              <b-button
                size="sm"
                variant="primary"
                class="mr-1"
                title="Ir a la cuenta"
                @click="viewDebtor()"
              >
                <i class="fa fa-eye"></i> Ir a la deudor
              </b-button>
            </div>

            <activity-component
              :customer_id="this.taskSelected.customer_id"
              :debtor_id="this.taskSelected.debtor_id"
              :private="'S'"
              :_task="this.taskSelected"
              :_disabled="true"
              v-if="
                this.taskSelected.customer_id || this.taskSelected.debtor_id
              "
              :title="
                this.taskSelected.customer_name != null
                  ? this.taskSelected.customer_name
                  : this.taskSelected.debtor_name
              "
              :dlg="'dlgCrearActividad'"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA EL COMPONENTE DE CREAR ACTIVIDADES O TASK -->
  </div>
</template>

<script>
import ActivityComponent from "@/components/Activity.vue";
import "fullcalendar/dist/locale/es";
export default {
  name: "Task",
  components: { ActivityComponent },
  props: {
    caption: {
      type: String,
      default: "Tareas",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      lstStaff: [],
      lstLawyers: [],
      staff_id: null,
      lstTaskStatus: [],
      status_id: null,
      lstTaskType: [],
      type_id: null,
      process: null,
      taskSelected: {},
      config: {
        locale: "es",
        defaultView: "month",
        editable: false,
        timeFormat: "hh:mm a",
      },
      calendarEvents: [],
    };
  },
  mounted() {
    // role_id: 1 => ADMINISTRADOR
    // role_id: 2 => COMERCIAL
    // role_id: 4 => PEJURIDICO
    // role_id: 5 => JURIDICO
    // role_id: 6 => CLIENTE
    // role_id: 7 => GERENTE COMERCIAL
    // role_id: 8 => GERENTE PREJURIDICO
    // role_id: 9 => GERENTE JURIDICO

    // VALIDAR SI INGRESA UN COMERCIAL
    let auth = JSON.parse(localStorage.getItem("auth"));
    if (this.role_id == 2 || this.role_id == 5) {
      this.staff_id = auth[0].staff_id;
    }

    switch (this.role_id) {
      case "2": // COMERCIAL
      case "7": // GERENTE COMERCIAL
        this.process = "C";
        break;

      case "5": // JURIDICO
      case "9": // GERENTE JURIDICO
        this.process = "J";
        break;
    }

    this.changeProcces();
    this.getTaskStatus();
    this.getTasks();
  },
  methods: {
    changeProcces() {
      this.getStaffs();
      this.getTaskType();
      this.getTasks();
    },
    getStaffs() {
      if (this.process) {
        //LISTADO DE STAFF'S: 42: COMERCIAL
        this.$http
          .get(`${this.$urlApi}staffs/type/42?token=${this.token}`)
          .then(
            (response) => {
              this.lstStaff = response.data.data;
              // console.log(response.data.data);
            },
            (error) => {
              console.log(error);
            }
          );

        //ABOGADOS => 44: Jurídico
        this.$http
          .get(`${this.$urlApi}staffs/type/44?token=${this.token}`)
          .then(
            (response) => {
              this.lstLawyers = response.data.data;
              hideLoader();
            },
            (error) => {
              console.log(error);
            }
          );
      }
    },
    getTaskType() {
      showLoader();
      if (this.process) {
        let type = this.process == "C" ? 6 : 22;
        // 6: LISTADO DE TIPOS DE ACTIVIDAD (TASK)
        this.$http
          .get(`${this.$urlApi}parameters/${type}?token=${this.token}`)
          .then(
            (response) => {
              this.lstTaskType = response.data.data;
              //console.log(response.data.data)
            },
            (error) => {
              console.log(error);
              hideLoader();
            }
          );
      }
    },
    getTaskStatus() {
      showLoader();

      // 5: LISTADO DE ESTADO DE LAS ACTIVIDADES O TAREAS
      this.$http.get(`${this.$urlApi}parameters/5?token=${this.token}`).then(
        (response) => {
          this.lstTaskStatus = response.data.data;
          hideLoader();
        },
        (error) => {
          console.log(error);
          hideLoader();
        }
      );
    },
    getTasks() {
      showLoader();
      this.$http
        .get(
          `${this.$urlApi}tasks/staff/${this.staff_id}/type/${this.type_id}/status/${this.status_id}/process/${this.process}?token=${this.token}`
        )
        .then(
          function (response) {
            this.calendarEvents = response.data.data;
            console.log(response.data.data);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    closetask() {
      this.taskSelected = {};
      $("#dlgCrearActividad").modal("hide");
    },
    viewtask(event) {
      console.log(event);
      $("#dlgCrearActividad").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL

      this.taskSelected = {
        id: event.id,
        staff_id: event.staff_id,
        customer_id: event.customer_id,
        debtor_id: event.debtor_id,
        process_id: event.process_id,
        date: event.date,
        name: event.name,
        task: event.task,
        type: event.type,
        private: event.private,
        latitude: event.latitude,
        longitude: event.longitude,
        system: event.system,
        status_id: event.status_id,
        customer_name: event.customer_name,
        debtor_name: event.debtor_name,
      };
      $("#dlgCrearActividad").modal("show");
    },
    viewCustomer() {
      let url = `${
        location.origin
      }/#/customers/view/${this.taskSelected.customer_id.toString()}`;
      window.open(url, "_blank");
    },
    viewDebtor() {
      let url = `${
        location.origin
      }/#/debtors/view/${this.taskSelected.debtor_id.toString()}`;
      window.open(url, "_blank");
    },
  },
};
</script>
